module.exports = "<p>wisdom-media works!</p>\n"